// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
html,
body,
#__layout {
  height: 100%;
}
.docu-vue-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.content {
  flex: 1 0 auto;
  padding: var(--space) var(--space) 0;
  width: 100%;
}
.content::after {
  content: '\\00a0'; /* &nbsp; */
  display: block;
  margin-top: var(--space);
  height: 0px;
  visibility: hidden;
}
.footer {
  flex-shrink: 0;
}
.mo-information--gray {
  color: #a9a9a9;
}
.iwgf2__languages-list.js-iwgf2-languages-list {
  display: none;
}
.mo-header-wrapper{
  position: fixed;
  width: 100%;
  z-index: 999;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
